import clsx from 'clsx';
import Link from 'next/link';

import { ReactComponent as Chevron } from '@pflegia/ui/icons/chevron.svg';

interface ClusterButtonProps {
  href: string;
  label: string;
  testId: string;
  isFullWidth?: boolean;
  onClick?: () => void;
}

const ClusterButton = ({ href, label, testId, isFullWidth = false, onClick }: ClusterButtonProps) => (
  <Link
    href={href}
    onClick={onClick}
    className={clsx(
      'border-primary-200 m-1 flex items-center rounded-xl border-2 p-3 font-sans text-lg wrap-break-word shadow-lg duration-150 ease-in-out',
      'hover:border-primary hover:bg-primary focus:border-primary hover:cursor-pointer hover:text-white hover:shadow-xl',
      isFullWidth ? 'text-primary w-full justify-between text-left' : 'text-center',
    )}
    data-testid={`cluster-button-${testId}`}>
    {label}
    {isFullWidth && <Chevron />}
  </Link>
);

export default ClusterButton;
